const actionFormatCheckerMiddleware = store => next => action => {
  // first check if the action was an object. Sometimes we return a function, for instance when listening for browser resizes
  if (typeof action === 'object') {
    const { type } = action
    // check the action's type was defined
    if (type === undefined || type === 'undefined') {
      console.error('An action object with an undefined type was dispatched')
      console.dir(action)
      console.trace()
    }
  }
  return next(action)
}

export default actionFormatCheckerMiddleware
